import { p as proxyCustomElement, H, h, a as Host } from './index.js';
import { d as defineCustomElement$2 } from './p-Dr61d_nc.js';

const draggableListItemCss = ".wui-draggable-list-item{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;align-items:center;background-color:hsla(0,0%,100%,.001);border-bottom:1px solid var(--jw-theme-surface-border-border-color);box-sizing:border-box;color:var(--jw-theme-surface-text-default-color);display:flex;font-family:Open Sans;font-size:.875rem;font-weight:400;gap:1rem;letter-spacing:-.0004em;line-height:1.25rem;line-height:normal;padding:1rem;transition:background-color .1s ease-in-out;width:100%}.wui-draggable-list-item *,.wui-draggable-list-item :after,.wui-draggable-list-item :before{box-sizing:inherit}.wui-draggable-list-item img{flex:none;overflow:hidden;text-overflow:ellipsis;white-space:pre-line}.wui-draggable-list-item__content{height:100%;width:100%}.wui-draggable-list-item__drag{border-radius:50%;cursor:grab;height:1rem;width:1rem}.wui-draggable-list-item__drag wui-icon{color:var(--jw-theme-surface-text-description-color);height:1rem;width:1rem}.wui-draggable-list-item__drag:active{cursor:grabbing}.wui-draggable-list-item.-dropzone{background:var(--jw-theme-surface-item-hover-bg-color)}.wui-draggable-list-item.-chosen{background-color:var(--jw-theme-surface-item-active-alt-bg-color)}.wui-draggable-list-item:hover{background-color:var(--jw-theme-surface-item-hover-bg-color)}.wui-draggable-list-item:only-child{border:none}.wui-draggable-list-item:only-child .wui-draggable-list-item__drag{display:none}";

const WuiDraggableListItem$1 = /*@__PURE__*/ proxyCustomElement(class WuiDraggableListItem extends H {
    constructor() {
        super();
        this.__registerHost();
    }
    render() {
        return (h(Host, { key: 'c6bb4322b0efeff293690b2bc2e05e3e402001f9', class: "wui-draggable-list-item" }, h("div", { key: '15de11391ab7de2ba224d7d61d6a349a71c6bf65', class: "wui-draggable-list-item__drag" }, h("wui-icon", { key: 'a543edd3e32a9b4790e30a58fc9f253163ed614c', name: "grip-vertical" })), h("div", { key: '1277f55c33e3c461b7a46ec57aa1403faf387f96', class: "wui-draggable-list-item__content" }, h("slot", { key: '5e8abdf5812447c3c36a816b7288f3f9153bb97a' }))));
    }
    static get style() { return draggableListItemCss; }
}, [260, "wui-draggable-list-item", {
        "uid": [513]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["wui-draggable-list-item", "wui-icon"];
    components.forEach(tagName => { switch (tagName) {
        case "wui-draggable-list-item":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, WuiDraggableListItem$1);
            }
            break;
        case "wui-icon":
            if (!customElements.get(tagName)) {
                defineCustomElement$2();
            }
            break;
    } });
}
defineCustomElement$1();

const WuiDraggableListItem = WuiDraggableListItem$1;
const defineCustomElement = defineCustomElement$1;

export { WuiDraggableListItem, defineCustomElement };
